import { NaturalNumber_Schema } from "@/utilities/schema";

export const CollectibleId_Schema = NaturalNumber_Schema;
